import { Component, EventEmitter, Input, OnInit, Output, Inject, ElementRef, ViewChild } from '@angular/core';
import { DOCUMENT, NgIf, NgStyle } from '@angular/common';
import * as moment from 'moment';
import * as _ from 'lodash'
import { environment } from 'src/environments/environment';
import { SessionMgmtService } from '../../services/session-mgmt/session-mgmt.service';
import { DownloadService } from '../../services/downloads/download.service';
import { UtilsService } from '../../services/utils/utils.service';
import { ToastService } from '../../services/toast/toast.service';
// export module
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import html2canvas from 'html2canvas';
import { Papa } from 'ngx-papaparse';
import { EngagementService } from '../../services/engagement/engagement.service';
import { LtmsDropdownComponent } from '../ltms-dropdown/ltms-dropdown.component';

@Component({
    selector: 'app-ltms-widget-tools',
    templateUrl: './ltms-widget-tools.component.html',
    styleUrls: ['./ltms-widget-tools.component.scss'],
    imports: [NgIf, LtmsDropdownComponent, NgStyle]
})
export class LtmsWidgetToolsComponent implements OnInit {
  @ViewChild('viewTypeSelector') viewTypeSelector!: ElementRef;
  @Input() elementId: string = '';
  @Input() config: any = {
    "trendSelector": false,
    "downloadFromJob": false,
    "dashboardReportingJob":false,
    "viewSelector": {
      enable: false,
      type: 'chart'
    },
    "download": {
      enable: true,
      componentId: '',
      downloadType:"csv",
      query:{},
      data: {}
    },
    "fullscreen": {
      enable: true,
      componentId: ''
    },

  }
  @Input() excludeTrends: any = [];
  @Output() onTrendTypeChange: any = new EventEmitter<any>();
  @Output() onViewChange: any = new EventEmitter<any>();
  isFullscreen: boolean = false;
  isFullscreenengagement: boolean = false;
  @Output() onFullscreenClick: any = new EventEmitter<any>();

  enableTrendTypeSelector: boolean = false;

  download: any = {
    enable: true,
    componentId: '',
    downloadType:"csv",
    query:{},
    data: {}
  };

  fullscreen: any = {
    enable: true,
    componentId: ''
  };

  viewSelector: any = {
    enable: false,
    type: 'chart'
  };

  dropdown: any = {
    groupBy: "",
    categorization: false,
    isDefaultSelection: true,
    preffix: "",
    comparisionField: "value",
    elementid: 'ltms-dropdown-' + this.getTimeStamp(),
    options: []
  };
  downloadQuery: any = {}
  selectedComponentId: string = '';
  customTrendTypes: any = [];
  selectedCustomTrendType: any = null;
  isFullScreenEnabled: boolean = false;
  downloadFromJob: boolean = false;
  dashboardReportingJob: boolean = false;
  //Trend types for dropdown
  hourly: any = { name: "Hourly", value: 0 };
  daily: any = { name: "Daily", value: 1 };
  weekly: any = { name: "Weekly", value: 2 };
  monthly: any = { name: "Monthly", value: 3 };
  quartely: any = { name: "Quarterly", value: 4 };
  yearly: any = { name: "Yearly", value: 5 };
  dateObj: any = _.get(Helpers, 'datePicker', {});
  viewType: string = 'absolute';

  isViewSelectorOpen: boolean = false;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private papa: Papa,
    private sessionService: SessionMgmtService,
    private downloadService: DownloadService,
    private _utilsService: UtilsService,
    private _toastService: ToastService,
    private engagementService: EngagementService
  ) { }

  ngOnInit(): void {
    // this.initializeTrendSelector()
     this.engagementService.isFullscreenEngagement$.subscribe(value => {
      this.isFullscreenengagement = value;
    });
  }
  ngOnChanges() {
    this.enableTrendTypeSelector = _.get(this.config, 'trendSelector', false);
    this.downloadFromJob = _.get(this.config, 'downloadFromJob', false);
    this.dashboardReportingJob = _.get(this.config, 'dashboardReportingJob', false)
    this.download = _.get(this.config, 'download', {});
    this.fullscreen = _.get(this.config, 'fullscreen', {});
    this.viewSelector = _.get(this.config, 'viewSelector', {});
    if (this.enableTrendTypeSelector) {
      this.initializeTrendSelector();
    }

  }

  ngAfterViewInit() {
    document.addEventListener('click', (event) => {
      if (this.viewTypeSelector && this.viewTypeSelector.nativeElement !== event.target && !this.viewTypeSelector.nativeElement.contains(event.target)) {
        this.isViewSelectorOpen = false;
      }
    });
  }

  getTimeStamp() {
    return new Date().getTime();
  }
  // Fullscreen Functions start
  changeFullscreenMod() {
    const elementId = _.get(this.fullscreen, 'componentId', '');
    try {
      if (!_.isEmpty(elementId)) {

        const documentElement: any = document.getElementById(elementId);
        if (documentElement) {
          if (!this.isFullScreenEnabled) {
            this.isFullScreenEnabled = true;
            if (documentElement.requestFullscreen) {
              documentElement.requestFullscreen();
            } else if (documentElement.mozRequestFullScreen) {
              /* Firefox */
              documentElement.mozRequestFullScreen();
            } else if (documentElement.webkitRequestFullscreen) {
              /* Chrome, Safari and Opera */
              documentElement.webkitRequestFullscreen();
            } else if (documentElement.msRequestFullscreen) {
              /* IE/Edge */
              documentElement.msRequestFullscreen();
            }
  
          } else {
            this.isFullScreenEnabled = false;
            if (this.document.exitFullscreen) {
              this.document.exitFullscreen();
            } else if (this.document.mozCancelFullScreen) {
              /* Firefox */
              this.document.mozCancelFullScreen();
            } else if (this.document.webkitExitFullscreen) {
              /* Chrome, Safari and Opera */
              this.document.webkitExitFullscreen();
            } else if (this.document.msExitFullscreen) {
              /* IE/Edge */
              this.document.msExitFullscreen();
            }
  
          }
        }
        // this.isFullscreen = !this.isFullscreen;
        // this.onFullscreenClick.emit(this.isFullscreen);

      }
    } catch (e: any) {
      // this.isFullscreen = !this.isFullscreen;
      //   // this.onFullscreenClick.emit(this.isFullscreen);
      // this.isFullScreenEnabled = false;
      console.log("Error on fullscrren function", e)
    }


  }
  changeFullscreenForEnagagement(){
    this.engagementService.setFullscreenEngagement(!this.engagementService.getFullscreenEngagement())
    this.onFullscreenClick.emit(this.isFullscreen);
  }
  // Fullscreen Functions start
  // Trend Type selector Functions Start
  initializeTrendSelector() {
    const datePicker = _.get(Helpers,'datePicker',{})
    var from = moment( datePicker.startDate, "YYYYMMDD").startOf('date');
    var to = moment( datePicker.endDate, "YYYYMMDD").endOf('date');
    this.customTrendTypes = [];

    // If custom date range is selected then it calculates the difference and possible trends
    if (datePicker.isCustomDateRangeSelected || datePicker.selectedTrend == undefined) {
      var dtDiff = to.diff(from, 'days');
      if (dtDiff == 0) {
        // This condition is used because the date difference of one and two days is 0
        if (datePicker.startDate == datePicker.endDate) {
          this.customTrendTypes.push(this.hourly);
        } else {
          this.customTrendTypes.push(this.daily);
        }
      } else if (dtDiff <= 6) {
        this.customTrendTypes.push(this.daily);
      } else if (dtDiff <= 30) {
        this.customTrendTypes.push(this.daily);
        this.customTrendTypes.push(this.weekly);
      } else if (dtDiff <= 91) {
        this.customTrendTypes.push(this.weekly);
        this.customTrendTypes.push(this.monthly);
      } else if (dtDiff <= 364 || this.isYearSelected(from,to)) {
        this.customTrendTypes.push(this.weekly);
        this.customTrendTypes.push(this.monthly);
        this.customTrendTypes.push(this.quartely);
      } else {
        this.customTrendTypes.push(this.monthly);
        this.customTrendTypes.push(this.quartely);
        this.customTrendTypes.push(this.yearly);
      }
    } else {
      // If custom date range is not selected then it calculates based on trends and difference
      var trendType = datePicker.selectedTrend;
      if (trendType == 1) {
        this.customTrendTypes.push(this.hourly);
      } else if (trendType == 2) {
        this.customTrendTypes.push(this.daily);
      } else if (trendType == 3) {
        this.customTrendTypes.push(this.daily);
        this.customTrendTypes.push(this.weekly);
      } else if (from.quarter() == to.quarter() && from.year() == to.year()) {
        this.customTrendTypes.push(this.weekly);
        this.customTrendTypes.push(this.monthly);
      } else if (from.year() == to.year()) {
        this.customTrendTypes.push(this.weekly);
        this.customTrendTypes.push(this.monthly);
        this.customTrendTypes.push(this.quartely);
      } else {
        this.customTrendTypes.push(this.weekly);
        this.customTrendTypes.push(this.monthly);
        this.customTrendTypes.push(this.quartely);
      }
    }

    if (this.excludeTrends && this.excludeTrends.length) {
      this.customTrendTypes = _.filter(this.customTrendTypes, (trend: any) => {
        if (!(this.excludeTrends.includes(trend.value))) {
          return trend;
        }
      });
    }

    if (this.customTrendTypes.length) {
      this.selectedCustomTrendType = this.customTrendTypes[0];
      this.onTrendTypeChange.emit(this.selectedCustomTrendType);
    }
    this.dropdown.options = this.customTrendTypes;
    this.dropdown.elementid = 'ltms-dropdown-' + this.getTimeStamp();
  }

  isYearSelected(from, to) {
    var startOfYear = moment(from).startOf('year').startOf('day');
    var endOfYear = moment(from).endOf('year').endOf('day');
    
    return from.isSame(startOfYear) && to.isSame(endOfYear);
}

  onFilterChange(data: any) {
    this.onTrendTypeChange.emit(data);
  }
  // Trend Type selector Functions Start
  // View Selector Function Start
  toggleViewSelector(event: Event) {
    event.stopPropagation();
    this.isViewSelectorOpen = !this.isViewSelectorOpen;
  }

  onViewTypeChange(viewType: string) {
    this.viewType = viewType;
    this.isViewSelectorOpen = false;
    this.onViewChange.emit(viewType);
  }
  // View Selector Function End

  // Report Download Functions start
  // All required function for download is written here
  downloadReport(event:any) {
    // saveAs = 'pdf';
    event.stopPropagation()
    let saveAs:any = _.get(this.download, 'downloadType', '');
    saveAs = this.config.downloadFromJob ? "jobs" : saveAs;
    saveAs = this.config.dashboardReportingJob ? "dashboardReportingJob" : saveAs
    const componentId = _.get(this.download, 'componentId', '');
    const dataObject = _.get(this.download, 'data', {});
    const queryObject = _.get(this.download, 'query', {});
    switch (saveAs) {
      case "image":
        this.downloadAsImage(componentId);
        break;
      case "pdf":
        this.downloadAsPDF(dataObject);
        break;
      case 'jobs':
        this.createDownloadJob(queryObject);
        break;
      case 'dashboardReportingJob':
        this.createDashboardReportingJob(queryObject);
        break;
      case 'csv':
      default:
        this.downloadAsCSV(dataObject);
        break;

    }

  }

  downloadAsImage(elementId: string) {
    const htmlEl: any = document.getElementById(elementId);
    if (htmlEl.nodeName != 'CANVAS') {
      html2canvas(htmlEl).then((canvas) => {
        this.saveAsImage(canvas);
      });
    } else {
      this.saveAsImage(htmlEl);
    }

  }

  downloadAsCSV(data: any) {
    var ReportTitle = data.title || '';
    var JSONData = data.rows;
    var fileName = data.fileName || 'Report';
    fileName += '_' + this.getDateValue();

    // //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    var arrData = (JSONData && typeof JSONData != 'object') ? JSON.parse(JSONData) : JSONData;

    var CSV = '';
    // //Set Report title in first row or line

    CSV += 'Report name :,"' + ReportTitle + '"\r';

    if (!data.reportDate) {
      CSV += 'Report Date :, "' + this.getFormatedReportDate(Helpers, 'startDate', 'DD-MMM-YYYY') + ' to ' + this.getFormatedReportDate(Helpers, 'endDate', 'DD-MMM-YYYY') + '"\r';
    } else {
      CSV += 'Report Date :, "' + data.reportDate + '"\r';
    }

    var isAccount = _.get(Helpers, 'isAccount');
    var accountName =  _.get(Helpers, 'accountDetails.name', '');
    accountName = _.get(Helpers, 'accountDetails.display_name', accountName)
      CSV += 'For Account :, "' + accountName + '"\r';
    if(Helpers.brandDetails && Helpers.brandDetails.name) {
      var brandName = Helpers.brandDetails.name;
      CSV += 'For Project :, "' + brandName + '"\r';
    }

    if (data.interaction) {
      CSV += 'Interaction :, "' + data.interaction + '"\r';
    }

    CSV += 'Downloaded On :,"' + moment().format('DD-MMM-YYYY hh:mm:ss a') + '"\r';

    // // User Details
    var userResponse = _.get(Helpers, 'managerDetails', '');
    if (userResponse && _.hasIn(userResponse, 'manager.name')) {
      CSV += 'Downloaded By :, "' +userResponse.manager.name + '"\r';
    }

    



    CSV += '\n\n';
    if (data.hasMultipleReports) {
      _.each(arrData, (object: any) => {
        var dataObj: any = this.prepareCsvData(object.columns, object.rows);
        dataObj.header = true;
        CSV += this.papa.unparse(dataObj);
        CSV += '\n\n';
      })
    } else {
      var dataObj: any = this.prepareCsvData(data.columns, data.rows);
      dataObj.header = true;
      CSV += this.papa.unparse(dataObj);
    }

    if (CSV == '') {
      alert("Invalid data");
      return;
    }

    //this will remove the blank-spaces from the title and replace it with an underscore
    fileName = fileName.replace(/ /g, "_");

    // //Initialize file format you want csv or xls
    var uri = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(CSV);

    const downloadData = {
      _id: this.downloadService.getDownloadId(),
      filename: fileName,
      created_date: new Date().toISOString(),
      orignal_filename: fileName + ".csv",
      fileType: 'csv',
      dataSource: 'dashboard',
      progress: 100,
      uri: uri
    };
    this.downloadService.updateList(downloadData);
    this.downloadService.showDownloadSideBar(true);
  }

  downloadAsPDF(data: any) {
    const doc = new jsPDF()
    var ReportTitle = data.title || '';
    var JSONData = data.rows;
    var fileName = data.fileName || 'Report';
    fileName += '_' + this.getDateValue();

    let arrData = (JSONData && typeof JSONData != 'object') ? JSON.parse(JSONData) : JSONData;
    const headerStyle: any = { fillColor: "#EDEDED", textColor: "#000000", };
    // // User Details
    let managerName = '';
    var userResponse = this.sessionService.getData('LOGIN_RESPONSE');
    if (userResponse && _.hasIn(userResponse, 'manager.name')) {
      managerName = _.get(userResponse, 'manager.name', '');
    }
    // Add images and text to the PDF
    let imageUrl = "assets/images/LW2_Logo.png";
    if (data.logo_url) {
      imageUrl = "https:" + data.logo_url;
    }
    let reportDate = data.reportDate || '';
    if (!data.reportDate) {
      reportDate = '' + this.getFormatedReportDate(Helpers, 'startDate', 'DD-MMM-YYYY') + ' to ' + this.getFormatedReportDate(Helpers, 'endDate', 'DD-MMM-YYYY');
    }
    var isAccount = localStorage.getItem('isAccount');
    const accountOrProjectName = (isAccount) ? Helpers.accountDetails.name : Helpers.brandDetails.name;

    doc.setProperties({ title: fileName });
    doc.addImage(imageUrl, 'JPEG', 10, 5, 40, 12);
    doc.setFontSize(10);
    doc.setFont('custom', 'bold');
    doc.text(ReportTitle, 150, 12);
    // Line width in units (you can adjust this)
    doc.setLineWidth(0.1);

    doc.setDrawColor(200, 200, 200);
    doc.line(10, 18, 200, 18);
    doc.text((isAccount) ? 'For Account :' : 'For Project :', 13, 23);
    doc.text('Downloaded By :', 13, 28);
    doc.text("Downloaded On :", 13, 33);
    doc.text("Report Date :", 13, 38);

    doc.setFont('custom', 'normal');
    doc.text(accountOrProjectName, 35, 23);
    doc.text(managerName, 40, 28);
    doc.text(moment().format('DD-MMM-YYYY hh:mm:ss a'), 40, 33);
    doc.text(reportDate, 37, 38);
    doc.line(10, 40, 200, 40);

    autoTable(doc, { startY: 40 });

    if (data.hasMultipleReports) {

      _.each(arrData, (object: any, index: string) => {
        const columsStyles: any = this.getColumnsStyle(object.columns);
        const pdfData = this.preparePdfData(object.columns, object.rows);
        autoTable(doc, {
          headStyles: headerStyle,
          columnStyles: columsStyles,
          margin: { top: 10 },
          columns: object.columns,
          body: pdfData
        });
      });
    } else {
      const columsStyles: any = this.getColumnsStyle(data.headers);
      const pdfData = this.preparePdfData(data.columns, data.rows);
      autoTable(doc, {
        headStyles: headerStyle,
        columnStyles: columsStyles,
        margin: { top: 10 },
        columns: data.columns,
        body: pdfData
      });
    }

    // doc.save('table.pdf')//use for debuging only if pdf format not good
    // doc.output('dataurlnewwindow'); //use for debuging only if pdf format not good
    const uri = doc.output('datauristring')
    const downloadData = {
      _id: this.downloadService.getDownloadId(),
      filename: fileName,
      created_date: new Date().toISOString(),
      orignal_filename: fileName + ".pdf",
      fileType: 'pdf',
      dataSource: 'dashboard',
      progress: 100,
      uri: uri
    }
    this.downloadService.updateList(downloadData)
    this.downloadService.showDownloadSideBar(true)
  }

  getColumnsStyle(headers: any) {
    const columsStyles: any = {};
    _.each(headers, (value: any, index: any) => {
      if (index == 0) {
        columsStyles[index] = {
          halign: 'left',
          fillColor: "#FFF",
          textColor: "#000000",
          lineWidth: { bottom: 1 },
          lineColor: "#EDEDED"
        }
      } else {
        columsStyles[index] = {
          halign: 'center',
          fillColor: "#FFF",
          textColor: "#000000",
          lineWidth: { bottom: 1 },
          lineColor: "#EDEDED"
        }
      }
    })
    return columsStyles;
  }

  prepareCsvData(columns: any, data: any) {
    columns = _.orderBy(columns, ['order'], ['asc']);
    let csvData: any = {
      fields: _.map(columns, 'header'),
      data: []
    }
    _.each(data, (row: any) => {
      let temp: any = [];
      _.each(columns, (column: any) => {
        const value = _.get(row, column.dataKey, column.defaultValue);
        temp.push(value);
      })
      csvData.data.push(temp);
    });

    return csvData;
  }
  preparePdfData(columns: any, data: any) {

    let pdfData: any = []
    _.each(data, (row: any) => {
      let temp: any = {};
      _.each(columns, (column: any) => {
        const value = _.get(row, column.dataKey, column.defaultValue);
        temp[column.dataKey] = value;
      });
      pdfData.push(temp);
    });

    return pdfData;
  }
  getFormatedReportDate(object: any, key: string, format: string) {
    const date = _.get(object, 'datePicker.' + key, '');
    if (!_.isEmpty(date)) {
      return moment(date, 'YYYYMMDD').format(format);
    }
    return date;

  }
  saveAsImage(canvas: any) {
    const uri = canvas.toDataURL('image/jpeg');
    const downloadData = {
      _id: this.downloadService.getDownloadId(),
      filename: "image",
      orignal_filename: "image.jpg",
      fileType: 'jpg',
      created_date: new Date().toISOString(),
      dataSource: 'dashboard',
      progress: 100,
      uri: uri

    }
    this.downloadService.updateList(downloadData)
    this.downloadService.showDownloadSideBar(true)
    // //this part will append the anchor tag and remove it after automatic click
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  }

  getDateValue() {
    let currentDate = new Date(),
      day: any = currentDate.getDate(),
      month: any = currentDate.getMonth() + 1,
      year: any = currentDate.getFullYear();
    if (day < 10) {
      day = '0' + day;
    }
    if (month < 10) {
      month = '0' + month;
    }
    return day + "_" + month + "_" + year;
  }
  createDashboardReportingJob(downloadQuery: any){
    this.downloadService.createDashboardReportingJob(downloadQuery).subscribe((reponse: any) => {
      if (reponse && reponse.litmus_job) {
        // reponse.litmus_job.filename = downloadQuery.report_name.split(' ').join('_');
        // reponse.litmus_job.orignal_filename= reponse.litmus_job.filename + ".csv"
        this.downloadService.updateList(reponse.litmus_job)
        this.downloadService.showDownloadSideBar(true);
      } else if (reponse && reponse.code == 4021) {
        this._toastService.showPopup("WARN", "Please Wait", "Report generation is in process.", 3500);
      } else {
        this._toastService.showPopup("ERROR", "Error", "Error while generating request.", 3500);
      }
    })
  }
  // TODO: need to update the create job for report download insted of preparing qurey hee we can take the query from parent widgets
  createDownloadJob(downloadQuery: any) {
    // var downloadQuery: any = {};
    // downloadQuery.brand_id = Helpers.brandDetail._id;
    // downloadQuery.field_id = configs.selectedCustomFilter.field_id;
    // downloadQuery.field_type = configs.selectedCustomFilter.type;
    // downloadQuery.api_url = this._utilsService.apiUrlGeneration(environment.actionV1, environment.actionV1.actionStatsComparisonData);
    // downloadQuery.question_id = configs.selectedQuestion.field_id;
    // downloadQuery.parameters = [];
    // downloadQuery.search_possible_values = false;
    // downloadQuery.job_name = "action_dashboard_reporting"
    // downloadQuery.job_type = 9
    // // downloadQuery.report_name = 'Action Summary - ' + _this.selectedCustomFilter.name;
    // var tabName = configs.tabeName
    // downloadQuery.report_name = 'Action Summary - ' + tabName + ' - ' + configs.selectedCustomFilter.name;
    // if (_.hasIn(configs, 'filterObj.nextFilter.field_id')) {
    //   downloadQuery.field_id = configs.selectedCustomFilter.field_id;
    //   downloadQuery.field_type = configs.selectedCustomFilter.type;
    // }
    // var universalFilter = Helpers.getUniversalFilter();
    // if (configs.overallWidgetDataQuery && configs.overallWidgetDataQuery.query) {
    //   downloadQuery.parameters.push(JSON.parse(JSON.stringify(configs.overallWidgetDataQuery.query)));
    // }
    // for (var idx in configs.drillDownSequence) {
    //   if (configs.drillDownSequence[idx].enabled && configs.drillDownExportDataQuery[idx].query) {
    //     downloadQuery.parameters.push(configs.drillDownExportDataQuery[idx].query)
    //   }
    // }
    // if (configs.compLeaderboardExportDataQuery && configs.compLeaderboardExportDataQuery.query && configs.enableLeaderboardComponent) {
    //   downloadQuery.parameters.push(Helpers.deepClone(configs.compLeaderboardExportDataQuery.query));
    //   downloadQuery.search_possible_values = true;
    // }
    this.downloadService.createDashboardReportJob(downloadQuery).subscribe((reponse: any) => {
      if (reponse && reponse.code == 0 && reponse.data && reponse.data.ops && reponse.data.ops.length > 0) {
        this.downloadService.updateList(reponse.data.ops[0]);
        this.downloadService.showDownloadSideBar(true);
      } else if (reponse && reponse.data && reponse.data.code == 4021) {
        this._toastService.showPopup("WARN", "Please Wait", "Report generation is in process.", 3500);
      } else {
        this._toastService.showPopup("ERROR", "Error", "Error while generating request.", 3500);
      }
    })
  }

  // Report Download Functions end
}
